export default __webpack_public_path__ + "static/media/avatar_gray.036c0e7f.svg";